import {useApi} from "~/composables/api/utils/useApi"

export const useMenuItemApi = () => ({
  async load() {
    const url = `/parameters/menu-items`
    const api = useApi()

    return api.makeRequest(url, 'get')
  }
})
